(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["race-print-footer"]) return;
  try {
    
  document.addEventListener('click', (event) => {
    const link = event.target instanceof Element ? event.target.closest('[data-race-cookie-preferences]') : null;
    if (!link || typeof window.privacyBanner?.showPreferences !== 'function') return;
    event.preventDefault();
    try {
      Promise.resolve(window.privacyBanner.showPreferences()).catch(() => window.location.assign(link.href));
    } catch {
      window.location.assign(link.href);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["race-print-product"]) return;
  try {
    
  if (!customElements.get('race-print-customizer')) {
    customElements.define('race-print-customizer', class extends HTMLElement {
      connectedCallback() {
        if (this.abortController) return;
        this.abortController = new AbortController();
        const signal = this.abortController.signal;
        this.form = this.querySelector('form');
        this.nameInput = this.querySelector('[data-race-name]');
        this.timeInput = this.querySelector('[data-race-time]');
        this.eventInput = this.querySelector('[data-race-event]');
        this.dateInput = this.querySelector('[data-race-date]');
        this.courseInput = this.querySelector('[data-race-course]');
        this.variantInput = this.querySelector('[data-race-variant]');
        this.error = this.querySelector('[data-race-error]');
        this.submitButton = this.querySelector('[data-race-submit]');
        this.ordersEnabled = this.dataset.ordersEnabled === 'true';
        if (!this.form || !this.nameInput || !this.timeInput || !this.variantInput) return;
        this.form.noValidate = true;
        this.form.addEventListener('input', (event) => {
          if (event.target instanceof HTMLInputElement) {
            event.target.setCustomValidity('');
            event.target.removeAttribute('aria-invalid');
          }
          this.clearError();
          this.updatePreview();
        }, { signal });
        this.variantInput.addEventListener('change', () => {
          this.clearError();
          this.updateVariant();
        }, { signal });
        this.form.addEventListener('submit', (event) => {
          if (!this.ordersEnabled) {
            event.preventDefault();
            this.showError(this.dataset.closedError);
            return;
          }
          const option = this.variantInput.selectedOptions[0];
          if (!option || option.dataset.available !== 'true') {
            event.preventDefault();
            this.showError(this.dataset.unavailableError, this.variantInput);
            return;
          }
          this.nameInput.value = this.nameInput.value.normalize('NFC').trim();
          this.timeInput.value = this.timeInput.value.trim();
          const checks = [
            [this.nameInput, Array.from(this.nameInput.value).length > 0 && Array.from(this.nameInput.value).length <= 40 && !/\p{C}/u.test(this.nameInput.value), this.dataset.nameError],
            [this.timeInput, /^(?!00:00:00$)[0-9]{2}:[0-5][0-9]:[0-5][0-9]$/.test(this.timeInput.value), this.dataset.timeError]
          ];
          if (this.eventInput) {
            this.eventInput.value = this.eventInput.value.trim();
            checks.push([this.eventInput, this.eventInput.value.length > 0 && this.eventInput.value.length <= 100, this.dataset.eventError]);
          }
          if (this.dateInput) checks.push([this.dateInput, this.dateInput.value !== '' && this.dateInput.validity.valid, this.dataset.dateError]);
          if (this.courseInput) {
            this.courseInput.value = this.courseInput.value.trim();
            let courseValid = this.courseInput.value === '';
            if (!courseValid) {
              try {
                const courseUrl = new URL(this.courseInput.value);
                courseValid = ['https:', 'http:'].includes(courseUrl.protocol) && courseUrl.hostname.length > 0;
              } catch { courseValid = false; }
            }
            checks.push([this.courseInput, courseValid, this.dataset.courseError]);
          }
          checks.forEach(([input]) => {
            input.setCustomValidity('');
            input.removeAttribute('aria-invalid');
          });
          const failed = checks.find(([, valid]) => !valid);
          if (failed) {
            event.preventDefault();
            const [input, , message] = failed;
            input.setCustomValidity(message);
            input.setAttribute('aria-invalid', 'true');
            this.showError(message, input);
            return;
          }
          if (!this.form.checkValidity()) {
            event.preventDefault();
            this.form.reportValidity();
            return;
          }
          this.clearError();
        }, { signal });
        this.updateVariant();
        this.updatePreview();
        document.fonts?.ready.then(() => { if (this.isConnected) this.updatePreview(); });
      }

      disconnectedCallback() {
        this.abortController?.abort();
        this.abortController = null;
      }

      clearError() {
        if (!this.error) return;
        this.error.hidden = true;
        this.error.textContent = '';
      }

      showError(message, input) {
        this.error.textContent = message;
        this.error.hidden = false;
        if (input) input.focus();
        else this.error.focus();
      }

      updateVariant() {
        const option = this.variantInput.selectedOptions[0];
        if (!option) return;
        const available = option.dataset.available === 'true';
        this.submitButton.disabled = !this.ordersEnabled || !available;
        this.submitButton.textContent = !this.ordersEnabled ? this.dataset.closedLabel : available ? this.dataset.submitLabel : this.dataset.unavailableLabel;
        this.querySelector('[data-variant-price]').textContent = option.dataset.price;
        const distance = this.querySelector('[data-preview-distance]');
        if (distance) distance.textContent = option.textContent.trim();
        const image = this.querySelector('[data-preview-image]');
        const placeholder = this.querySelector('[data-preview-placeholder]');
        const source = option.dataset.previewUrl;
        if (source) {
          if (image.getAttribute('src') !== source) image.src = source;
          image.hidden = false;
          placeholder.hidden = true;
        } else {
          image.removeAttribute('src');
          image.hidden = true;
          placeholder.hidden = false;
        }
      }

      updatePreview() {
        const namePreview = this.querySelector('[data-preview-name]');
        namePreview.textContent = this.nameInput.value.normalize('NFC').trim() || this.dataset.namePlaceholder;
        if (typeof namePreview.getComputedTextLength === 'function') {
          namePreview.style.fontSize = '32px';
          const measuredWidth = namePreview.getComputedTextLength();
          if (measuredWidth > 860) namePreview.style.fontSize = `${Math.max(22, 32 * 860 / measuredWidth)}px`;
        }
        this.querySelector('[data-preview-time]').textContent = this.timeInput.value.trim() || this.dataset.timePlaceholder;
        if (this.eventInput) this.querySelector('[data-preview-event]').textContent = this.eventInput.value.trim() || this.dataset.eventPlaceholder;
        if (this.dateInput) {
          let displayDate = this.dataset.datePlaceholder;
          if (/^\d{4}-\d{2}-\d{2}$/.test(this.dateInput.value)) {
            const [year, month, day] = this.dateInput.value.split('-').map(Number);
            const date = new Date(0);
            date.setFullYear(year, month - 1, day);
            date.setHours(12, 0, 0, 0);
            if (!Number.isNaN(date.getTime())) displayDate = new Intl.DateTimeFormat(document.documentElement.lang || 'en', { day: 'numeric', month: 'long', year: 'numeric' }).format(date);
          }
          this.querySelector('[data-preview-date]').textContent = displayDate;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
